<template>
    <el-dialog
      name="create"
      title="Создание новой анкеты, добавьте необходимые поля и нажмите кнопку создать"
      :visible="visible"
      :before-close="close"
      :width="'80%'"
    >

    <el-form ref="addForm" :rules="addFormRules" :model="addForm">
      <el-form-item label="Название" prop="title">
        <el-input autosize placeholder="Введите название анкеты..." v-model="addForm.title" name="title"></el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="Описание анкеты..."
          v-model="addForm.description"
          name="description"
          julia-data="sd"
        ></el-input>
      </el-form-item>
    </el-form>

    <slot slot="footer" class="dialog-footer">
      <el-button type="primary" name="create" :loading="loadAddForm" @click="addQuestionnaire()">Создать</el-button>
    </slot>

    </el-dialog>
</template>

<script>
export default {
  name: 'QuestionnaireAddModal',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: !!0,
      addForm: {},
      addFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Укажите описание', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    visible: {
      required: true
    }
  },
  created () {},
  methods: {
    addQuestionnaire () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loadAddForm = !!1
          this.addForm.type = 10
          this.$api.questionnaire
            .create(this.addForm)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Создана новая анкета'
              })
              this.$router.push({
                name: 'cpanel.questionnaire.item',
                params: { id: response.data.id }
              })
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка сохранения',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  &__mask {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.modal-content {
  max-width: 700px;
  height: 90%;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-body {
  max-width: 960px;
  margin: 20px auto;

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;
  &__icon {
    float: right;
    cursor: pointer;
  }
}
.modal-footer {
  padding: 40px 0;

  &__button {
    float: right;
  }
}
</style>
